import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useAnalytics } from "../hooks/useAnalytics";
import LoginModal from "./LoginModal";
import "./Home.css";

const Home = () => {
  const navigate = useNavigate();
  const { currentUser, isAdmin, logout } = useAuth();
  const { trackNav, trackAuth } = useAnalytics();
  const [showLoginModal, setShowLoginModal] = useState(false);

  const handleAlphabetsClick = () => {
    trackNav("alphabets");
    navigate("/alphabets");
  };

  const handleWordsClick = () => {
    trackNav("words");
    navigate("/words");
  };

  const handleSentencesClick = () => {
    trackNav("sentences");
    navigate("/sentences");
  };

  const handleUserIconClick = () => {
    if (currentUser) {
      // Show user menu or logout
      if (window.confirm("Do you want to logout?")) {
        trackAuth("logout");
        logout();
      }
    } else {
      trackAuth("login_modal_open");
      setShowLoginModal(true);
    }
  };

  return (
    <div className="home">
      <div className="header">
        <div className="profile-icon" onClick={handleUserIconClick}>
          {currentUser ? (
            <div className="user-info">
              {currentUser.photoURL ? (
                <img
                  src={currentUser.photoURL}
                  alt="Profile"
                  className="profile-image"
                />
              ) : (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
              )}
              {isAdmin && <span className="admin-badge">Admin</span>}
            </div>
          ) : (
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
              <circle cx="12" cy="7" r="4"></circle>
            </svg>
          )}
        </div>
      </div>

      <div className="main-content">
        <h1 className="title">Learn Japanese</h1>

        <div className="progress-section">
          <div className="progress-bar">
            <div className="progress-segment completed">
              <div className="progress-fill"></div>
            </div>
            <div className="progress-segment">
              <div className="progress-fill"></div>
            </div>
            <div className="progress-segment">
              <div className="progress-fill"></div>
            </div>
          </div>
          <div className="progress-labels">
            <span>Alphabets</span>
            <span>Words</span>
            <span>Sentences</span>
          </div>
        </div>

        <div className="navigation-buttons">
          <button className="nav-button" onClick={handleAlphabetsClick}>
            Alphabets
          </button>
          <button className="nav-button" onClick={handleWordsClick}>
            Words
          </button>
          <button className="nav-button" onClick={handleSentencesClick}>
            Sentences
          </button>
        </div>
      </div>

      <LoginModal
        isOpen={showLoginModal}
        onClose={() => setShowLoginModal(false)}
      />
    </div>
  );
};

export default Home;
